import { useEffect } from "react";
import { hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeTabs, showSchoolDrowdown } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { addNewStorageLocationRec, deleteStorageLocation, getStorageLocationsData, saveStorageLocation } from './../../../../../actions/storageLocationAction'
import { useState } from "react";
import { useAuthState } from "../../../../../context";
import { Card } from "react-bootstrap";
import { Button, CardBody, Col, Row, UncontrolledTooltip, Modal, ModalBody, ModalFooter, ModalHeader, } from "reactstrap";
import RTable from './../../../../table';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import confirmAlert from "../../../../conformAlert";
import StorageRecForm from "./storageRecForm";

const StorageLocations = (props) => {
    const { countrySettings } = props;
    const dispatch = useMenuTypeDispatch();
    const { otherInfo } = useAuthState();
    const [slRec, setSlRec] = useState({});
    const [slList, setSlList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saveRecLoading, setSaveRecLoading] = useState(false);
    const [slRecIsOpen, setSlrecIsOpen] = useState(false);

    useEffect(() => {
        hideMenuTypeTabs(dispatch);
        hideSchoolDrowdown(dispatch);
        return () => {
            showMenuTypeTabs(dispatch);
            showSchoolDrowdown(dispatch);
        }
    }, []);
    useEffect(() => {
        getStorageLocationList();
    }, [countrySettings]);

    const getStorageLocationList = async () => {
        setLoading(true);
        const res = await getStorageLocationsData(otherInfo.catererId);
        setLoading(false);
        if (res.error) {
            setSlList([]);
        } else {
            setSlList(res.data || []);
        }
    }
    const getCols = () => {
        const cols = [{
            Header: 'Id',
            accessor: 'id',
            style: { width: '100px' },

        }, {
            Header: 'Storage Location',
            accessor: 'storageLocationName',

        },
        {
            Header: 'Action',
            style: { width: '200px' },
            Cell: ({ row }) => {
                return <>
                    <Button id={`editButton-${row.original.id}`} color="falcon-primary" size="sm" className='mr-1' type="button" onClick={(e) => {
                        setSlRec({ ...row.original });
                        setSlrecIsOpen(true);
                    }} >
                        <FontAwesomeIcon icon="pencil-alt" transform="shrink-3" /> Edit
                    </Button>
                    <UncontrolledTooltip
                        placement="bottom"
                        target={`editButton-${row.original.id}`}
                    >
                        Edit Storage Location
                    </UncontrolledTooltip>
                    <Button id={`deleteButton-${row.original.id}`} color="falcon-primary" size="sm" className='mr-1' type="button" onClick={async (e) => {
                        const confirmStatus = await confirmAlert({
                            title: 'Delete Confirmation',
                            message:
                                'Are you sure you want to delete this storage location?'
                        });
                        if (!confirmStatus) {
                            return false;
                        }
                        deleteStorage(row.original.id);

                    }} >
                        <FontAwesomeIcon icon="trash-alt" transform="shrink-3" /> Delete
                    </Button>
                    <UncontrolledTooltip
                        placement="bottom"
                        target={`deleteButton-${row.original.id}`}
                    >
                        Delete Storage Location
                    </UncontrolledTooltip>
                </>
            }
        }
        ];
        return cols;
    }
    const saveRec = async (data) => {
        const { catererId } = otherInfo;
        if (data.id == 0) {
            const addRes = await addNewStorageLocationRec({ ...data, catererId });
            if (!addRes.error) {
                toast.success(addRes.data.message);
                hideSlModelPopup();
                getStorageLocationList();
            } else {
                toast.error(addRes.errorMessage);
            }
        } else {
            const saveRes = await saveStorageLocation({ ...data, catererId });
            if (!saveRes.error) {
                toast.success(saveRes.data.message);
                hideSlModelPopup();
                getStorageLocationList();
            } else {
                toast.error(saveRes.errorMessage);
            }
        }
    }
    const deleteStorage = async (id) => {
        const { catererId } = otherInfo;
        const res = await deleteStorageLocation({ id, catererId });
        if (!res.error) {
            toast.success(res.data.message);
            getStorageLocationList();
        } else {
            toast.error(res.errorMessage);
        }

    }
    const hideSlModelPopup = () => {
        setSlRec({});
        setSlrecIsOpen(false);
    }
    const storageLocationModelPopup = () => {
        return (<>
            <Modal isOpen={slRecIsOpen} toggle={hideSlModelPopup}>
                <ModalHeader toggle={hideSlModelPopup}>Storage Location Rec</ModalHeader>
                <ModalBody>
                    <StorageRecForm defaultValues={{ ...(slRec || {}) }}
                        loading={saveRecLoading} onCancelClick={async () => {
                            hideSlModelPopup();
                        }} onSubmitClick={async (data) => {
                            saveRec(data);
                        }} />
                </ModalBody>
            </Modal>
        </>)
    }

    return (<>
        <Card className='shadow-none border mb-2 mt-2'>
            <CardBody className='py-2'>
                <Row>
                    <Col className='align-self-center'>
                        <h5 className='text-primary fw-bold mb-0'>Manage Storage Locations</h5>
                    </Col>
                    <Col className='d-flex justify-content-end'>
                        <Button color="falcon-primary" size="sm" onClick={(e) => {
                            setSlRec({});
                            setSlrecIsOpen(true);

                        }}>
                            <FontAwesomeIcon icon="plus" transform="shrink-3" className="mr-1" />
                            Add New Storage Location
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} className="mt-2">
                        <RTable loading={loading} columns={getCols()}
                            data={slList} minRows="50" defaultPageSize={50} />
                    </Col>
                </Row>
            </CardBody>
            {
                storageLocationModelPopup()
            }
        </Card>
    </>)
}
export default StorageLocations;